import React from "react";
import Typography from "@material-ui/core/Typography";
import {detalleResources} from "../endpoints";
import {Card} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import TablaAjustes from "../components/TablaAjustes";
import tableicons from "../tableicons";
import MaterialTable from "material-table";
import SnackbarAlert from "../components/SnackbarAlert";

class DetalleConteo extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            id_o_barra: props.match.params.id_o_barra,
            tipo: props.match.params.tipo,
            tag:props.match.params.tag,
            id_codigo_tipo: props.match.params.id_codigo_tipo,
            mostrar_card: false,
            conteo: "",
            existe_ajuste:false,
            ajustes:[],
            mostrar_tabla:false,
            conteos:"",
            openSnack:false,
            severity: null,
            message:null
        }
    }

    obtenerDetalle = () =>{
        this.setState({openSnack:false, severity: null, message:null})
        if(this.state.tipo === "desagrupado"){
            detalleResources.getDetalleConteo(this.state.id_o_barra).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(data => {
                if(data.status_code === 200){
                    this.setState({mostrar_card:true, conteo:data.detalles})
                }
                else if (data.status_code === 401){
                    this.setState({openSnack:true,cargando:false, severity:data.severity, message:data.message})
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                console.error(error);
            });
        }
        else{
            detalleResources.getDetalleConteoAgrupado(this.state.id_o_barra,this.state.id_codigo_tipo,this.state.tag).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(data => {
                if(data.status_code === 200){
                    this.setState({mostrar_tabla:true,conteos:data.detalles})
                }
                else if (data.status_code === 401){
                    this.setState({openSnack:true,cargando:false, severity:data.severity, message:data.message})
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                console.error(error);
            });
        }
    }

    obtenerDetalleAjuste = () =>{
        this.setState({openSnack:false, severity: null, message:null})
        if(this.state.tipo === "desagrupado"){
            detalleResources.getDetalleAjustesConteo(this.state.id_o_barra).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(data => {
                if(data.status_code === 200){
                    if(data.detalles.length > 0){
                        this.setState({existe_ajuste:true, ajustes:data.detalles})
                    }
                }
                else if (data.status_code === 401){
                    this.setState({openSnack:true,cargando:false, severity:data.severity, message:data.message})
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                console.error(error);
            });
        }
        else{
            detalleResources.getDetalleAjusteAgrupado(this.state.tag,this.state.id_o_barra, this.state.id_codigo_tipo).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(data => {
                if(data.status_code === 200){
                    if(data.length > 0){
                        this.setState({existe_ajuste:true, ajustes:data.ajuste})
                    }
                }
                else if (data.status_code === 401){
                    this.setState({openSnack:true, severity:data.severity, message:data.message})
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                console.error(error);
            });

        }

    }

    componentDidMount() {
        this.obtenerDetalle()
        this.obtenerDetalleAjuste()
    }

    render() {
        return (
            <div>
                <Typography variant="h4" gutterBottom>
                    Detalle conteo {this.state.tipo}
                </Typography>
                {this.state.mostrar_card &&
                <Card style={{background:'#dbe9fc'}}>
                    <CardContent>
                        <Grid container spacing={3} alignItems={'center'} justifyContent={"flex-start"}>
                            <Grid item>
                                <b>Cód. escaneado: </b>{this.state.conteo.codigo}
                            </Grid>
                            <Grid item>
                                <b>Código tipo: </b>{this.state.conteo.codigo_tipo}
                            </Grid>
                            <Grid item>
                                <b>Descripción: </b>{this.state.conteo.descripcion}
                            </Grid>
                            <Grid item>
                                <b>Cantidad capt.: </b>{this.state.conteo.cantidad}
                            </Grid>
                            <Grid item>
                                <b>Fecha vencimiento: </b>{this.state.conteo.fecha_vencimiento === null ? "--" : this.state.conteo.fecha_vencimiento}
                            </Grid>
                            <Grid item>
                                <b>Factor: </b>{this.state.conteo.factor === null ? "--" : this.state.conteo.factor}
                            </Grid>
                            <Grid item>
                                <b>Tag: </b>{this.state.conteo.tag}
                            </Grid>
                            <Grid item>
                                <b>Hu: </b>{this.state.conteo.hu === null || this.state.conteo.hu === ""? "--" : this.state.conteo.hu}
                            </Grid>
                            <Grid item>
                                <b>Usuario capturador: </b>{this.state.conteo.nombre1 + " "+ this.state.conteo.nombre2  + " "+ this.state.conteo.apellido1  + " " + this.state.conteo.apellido2}
                            </Grid>
                            <Grid item>
                                <b>Fecha y hora de captura: </b>{new Date(Date.parse(new Date(this.state.conteo.timestamp) + ' UTC')).toLocaleString()}
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card> }
                { this.state.mostrar_tabla &&
                <MaterialTable
                    localization={{
                        toolbar: {
                            searchPlaceholder: 'Buscar'
                        },
                        header: {
                            actions: 'Acciones'
                        },
                        body:{
                            emptyDataSourceMessage: 'No hay datos para mostrar'
                        }
                    }}
                    options={{
                        pageSize: 10,
                        pageSizeOptions: [10, 25, 50, 100],
                        actionsColumnIndex: -1,
                        rowStyle: rowData => ({
                            backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                        }),
                        searchFieldStyle: {
                            width: "auto",
                        },
                        padding: "dense"
                    }}
                    icons={tableicons}
                    title=""
                    data={this.state.conteos}
                    columns={[
                        { title: 'Cód. escan.', field: 'codigo' },
                        { title: 'Cód. tipo', field: 'codigo_tipo' },
                        { title: 'Descripción', field: 'descripcion' },
                        { title: 'Cantidad capt.', field: 'cantidad' },
                        { title: 'Factor', field: 'factor' },
                        { title: 'Tag', field: 'tag'},
                    ]}
                    onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                />
                }
                {this.state.existe_ajuste &&
                    <div>
                        <br/>
                        <TablaAjustes datos={this.state.ajustes}/>
                    </div>
                }
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
            </div>
        )
    }
}

export default DetalleConteo